/* File: translator.js
 * Path: ananunadm/src/helpers/translator.js
 * Flat maps: ./translator-locales/*.js — Nested: translator-structure.js
 */
import { translationsEn } from "./translator-locales/en.js";
import { translationsRu } from "./translator-locales/ru.js";
import { translationsHy } from "./translator-locales/hy.js";
import { translationsTr } from "./translator-locales/tr.js";
import { translationsAr } from "./translator-locales/ar.js";
import { translationsZh } from "./translator-locales/zh.js";
import { translationsFa } from "./translator-locales/fa.js";
import { translationsHe } from "./translator-locales/he.js";
import { translationsFr } from "./translator-locales/fr.js";
import { translationsEs } from "./translator-locales/es.js";
import { translationsPt } from "./translator-locales/pt.js";
import { translatorStructured } from "./translator-structure.js";
import { userDashboardTranslations } from "./userDashboardTranslations.js";
import todoNotificationTranslations from "./todoNotificationTranslations.js";
import workloadMatrixTranslations from "./workloadMatrixTranslations.js";
import ticketAiTranslations from "./ticketAiTranslations.js";
import photosTranslations from "./photosTranslations.js";

const _localeMaps = {
	en: translationsEn,
	ru: translationsRu,
	hy: translationsHy,
	tr: translationsTr,
	ar: translationsAr,
	zh: translationsZh,
	fa: translationsFa,
	he: translationsHe,
	fr: translationsFr,
	es: translationsEs,
	pt: translationsPt
};

const _flatMerged = {};

for (const lang of ["en","ru","hy","tr","ar","zh","fa","he","fr","es","pt"]) {
	const slice = _localeMaps[lang];
	for (const key of Object.keys(slice)) {
		if (!_flatMerged[key]) _flatMerged[key] = {};
		_flatMerged[key][lang] = slice[key];
	}
}

export const Translations = {
	..._flatMerged,
	...translatorStructured,
	...userDashboardTranslations,
	...todoNotificationTranslations,
	...workloadMatrixTranslations,
	...ticketAiTranslations,
	...photosTranslations
};

export const T = (key, lang) => {
	return Translations[key]?.[lang || "en"] || Translations[key]?.en || key;
};
